/**
 * Copyright 2024, Optimizely
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export var ODP_USER_KEY;
(function (ODP_USER_KEY) {
    ODP_USER_KEY["VUID"] = "vuid";
    ODP_USER_KEY["FS_USER_ID"] = "fs_user_id";
    ODP_USER_KEY["FS_USER_ID_ALIAS"] = "fs-user-id";
})(ODP_USER_KEY || (ODP_USER_KEY = {}));
export var ODP_EVENT_ACTION;
(function (ODP_EVENT_ACTION) {
    ODP_EVENT_ACTION["IDENTIFIED"] = "identified";
    ODP_EVENT_ACTION["INITIALIZED"] = "client_initialized";
})(ODP_EVENT_ACTION || (ODP_EVENT_ACTION = {}));
export const ODP_DEFAULT_EVENT_TYPE = 'fullstack';
export const __platforms = ['__universal__'];
//# sourceMappingURL=constant.js.map